import { render, staticRenderFns } from "./ReferralCancellationModal.vue?vue&type=template&id=1249899a&scoped=true"
import script from "./ReferralCancellationModal.vue?vue&type=script&lang=js"
export * from "./ReferralCancellationModal.vue?vue&type=script&lang=js"
import style0 from "./ReferralCancellationModal.vue?vue&type=style&index=0&id=1249899a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1249899a",
  null
  
)

export default component.exports